// @TODO: Maybe auto generate this enum based on the enum from the backend?
export enum Permission {
  OrganizationCreate = "organization.create",
  OrganizationManage = "organization.manage",

  LocationManage = "location.manage",
  LocationUpdate = "location.update",

  EmployeesOverview = "employees.overview",
  EmployeesInvite = "employees.invite",
  EmployeesRolesManage = "employees.roles.manage",
  PatientsOverview = "patients.overview",
  PatientsManage = "patients.manage",
  ManagePatientQualityOrganizationConsents = "patient.quality_organization_consents.manage",
  PatientsInvite = "patients.invite",

  DossierIntakeView = "dossier.intake.view",
  DossierIntakeManage = "dossier.intake.manage",
  DossierIntakeJournalView = "dossier.intake.journal.view",
  DossierIntakeJournalSubmit = "dossier.intake.journal.submit",
  DossierTreatmentView = "dossier.treatment.view",
  DossierTreatmentManage = "dossier.treatment.manage",
  DossierTreatmentReferralManage = "dossier.treatment.referral.manage",

  DossierTreatmentJournalView = "dossier.treatment.journal.view",
  DossierTreatmentJournalSubmit = "dossier.treatment.journal.submit",

  InsurerContracts = "insurer.contracts",
  InsurerManage = "insurer.manage",
  InsurerRates = "insurer.rates",

  MessagesOverview = "messages.overview",
  CalendarOverview = "calendar.overview",
  StartDashboard = "start.dashboard",
  PlannerOverview = "planner.overview",
  MyDayOverview = "myday.overview",
  DeclarationTaskslist = "declaration.taskslist",
  DeclarationOverview = "declaration.overview",
  TasksTable = "tasks.table",
  RatesOverview = "rates.overview",
  ReferralsManage = "referrals.manage",
  BillingSettings = "billing.settings",

  ScheduleManageOwn = "schedule.manage.own",
  ScheduleManageAll = "schedule.manage.all",

  IntegrationsManage = "integrations.manage",

  EmbedConfigurations = "embed.configurations",

  PromManage = "prom.manage",

  ConcernContracts = "concern.contracts",

  LinkExistingEmployeesToLocations = "organisations.link-employee",
  GetAllEmployeesFromMultipleLocations = "organisations.all-employees",

  PromManagePatientAssessments = "prom.patient_assessments.manage",
  PromManageQualityOrganizations = "prom.quality_organizations.manage",

  GroupClassManage = "group.class.manage",
  QualityManagementOverview = "quality.management.overview",

  SubscriptionsManage = "subscriptions.manage",
  SubscriptionsView = "subscriptions.view",
  SubscriptionsSubscribersManage = "subscriptions.subscribers.manage",

  AlphaUserFeatures = "alpha.user.features",
  BetaUserFeatures = "beta.user.features",

  AuditLogView = "audit_log.view",

  ManagePatientIdentifiers = "patient.identifiers.manage",

  TrajectoriesOverview = "trajectories.overview",
  TrajectoriesManageAll = "trajectories.manage.all",

  AnnouncementsManage = "announcements.manage",

  ZorgmailMessagesView = "zorgmail.messages.view",
  ZorgmailMessagesManage = "zorgmail.messages.manage",

  PatientDocumentsView = "patient.documents.view",
  PatientDocumentsManage = "patient.documents.manage",
}
